import React from 'react';
import {
  styled,
  IconButton as MuiIconButton,
  IconButtonProps as MuiIconButtonProps,
} from '@mui/material';

export type StyledIconButtonProps = { variant?: 'square' | 'default' };

const StyledIconButton = styled(MuiIconButton, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<StyledIconButtonProps>(({ theme, variant }) => ({
  ...(variant === 'square' && {
    padding: theme.spacing(theme.spacingSizes.xxs),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.grey[300]}`,
    '&:hover': {
      backgroundColor: 'transparent',
      borderColor: theme.palette.grey[400],
    },
  }),
}));

export type IconButtonProps = StyledIconButtonProps & MuiIconButtonProps;

const IconButton: React.FC<IconButtonProps> = ({
  variant = 'default',
  children,
  ...props
}) => {
  return (
    <StyledIconButton variant={variant} {...props}>
      {children}
    </StyledIconButton>
  );
};

export default IconButton;
